import { ActionTypes } from "../constants";

const reduceDevelopmentNeeds = (state = null, action) => {

    switch (action.type) {
        case ActionTypes.GET_DEVELOPMENT_NEEDS_SUCCESS:
            return action.data || [];

        case ActionTypes.GET_DEVELOPMENT_NEEDS_FAILURE:
            return [];

        case ActionTypes.GET_DEVELOPMENT_NEED_SUCCESS:
            return [
                ...(state || []).filter(({id}) => Number(id) !== Number(action.payload.id)),
                action.data
            ];

        case ActionTypes.ADD_DEVELOPMENT_NEED_SUCCESS:
            return !state
                ? [action.data]
                : [
                    ...state,
                    action.data
                ];

        case ActionTypes.UPDATE_DEVELOPMENT_NEED_SUCCESS:
            return [
                ...(state || []).filter(({id}) => Number(id) !== Number(action.payload.id)),
                {
                    ...(state || []).find(({id}) => id === action.payload.id),
                    ...action.payload.params
                }
            ];

        case ActionTypes.DELETE_DEVELOPMENT_NEED_SUCCESS:
            return (state || []).filter(({id}) => Number(id) !== Number(action.payload.id));

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export const getDevelopmentNeed = (developmentNeeds, developmentNeedId) => !developmentNeeds ? null :  developmentNeeds.find(({id}) => Number(id) === Number(developmentNeedId));

export default reduceDevelopmentNeeds;
